import { Modal, AsyncSelect } from "components";
import { Button, Input } from "expano-components";
import getNotBundleProducts from "utils/select_options/getNotBundleProducts";
import useCreate from "hooks/useCreate";
import { useState } from "react";

const AddBundle = ({ bundle_id, refetch, handleClose }) => {
  const [component_id, setComponentId] = useState(null);
  const [quantity, setQuantity] = useState(1);

  const { is_creating, create } = useCreate({
    path: "/product_components",
    onSuccess: () => [refetch(), handleClose()],
  });

  const handleCreate = () => create({ component_id, bundle_id, quantity });

  return (
    <Modal
      size="md"
      handleClose={handleClose}
      header={{
        title: "Dodaj produkt",
      }}
      footer={
        <>
          <Button type="cancel" onClick={handleClose} />
          <Button
            type="add-green"
            text="Dodaj"
            disabled={!component_id || !quantity || is_creating}
            onClick={handleCreate}
          />
        </>
      }
    >
      <AsyncSelect
        label="Wybierz produkt, który będzie częścią bundla:"
        getData={(q) => getNotBundleProducts(q)}
        onChange={({ value }) => setComponentId(value)}
      />
      <Input
        label="Ilość"
        type="number"
        input={{
          name: "quantity",
          value: quantity,
          onChange: ({ target: { value } }) => setQuantity(value),
        }}
        meta={{}}
      />
    </Modal>
  );
};

export default AddBundle;
